import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
const FAQData = [
  {
    questNo: 1,
    quest: "Will KwikCheckout integration slow down our dev cycles?",
    response:
      "Kwik Engage enables two-way personalized campaigns, automates customer journeys, and provides deep insights for data-driven mYes. Owing to GoKwik’s experience and centricity to the eCommerce ecosystem, we offer the fastest and most seamless solution. KwikCheckout by GoKwik is an all-in-one, not one-size-fits-all solution tailored to suit every eCommerce brand, regardless of their growth stage. With KwikCheckout, eCommerce businesses have achieved up to a 40% increase in their overall conversion rate, along with a significant boost in gross merchandise value (GMV).",
  },
  {
    questNo: 2,
    quest: "Will we have to give up control over UI or logic?",
    response:
      "GoKwik offers best-in-market payment success rates, powered by strong payment partnerships. However, actual success rates may vary marginally (1-2%) based on factors like Shopify's payment acceptance, etc.",
  },
  {
    questNo: 3,
    quest: "Can we track and customize everything?",
    response:
      "No. Our one-click checkout solution is platform-agnostic and can be integrated with various eCommerce platforms including Shopify, WooCommerce, Magento, Salesforce Commerce Cloud, and more.",
  },
  {
    questNo: 4,
    quest: "Is this secure and scalable for peak traffic?",
    response:
      "The RTO Analytics Dashbord help in real-time and historial measurement of business metrics such as cash-on-delivery vs prepaid share, RTO %, prepaid uplift, etc. Such in-depth information allows eCommerce brands to make better decisions, especially in terms of dealing with high-risk shopping and bringing down their RTO rates.",
  },
];
const SectionEight = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  return (
    <div className="section-8-cc">
      <div className="section-8a-cc">
        <div className="container-fluid">
          <div
            className="flex align-items-center sect-5-cc"
            style={{
              justifyContent: isMobile ? "center" : "space-between",
              gap: "30px",
              margin: isMobile ? "0 0.2rem" : "0 5rem",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <div className="mid-text1-cc" style={{ justifyContent: "left" }}>
              <h1>Ready to see KwikCheckout in Action?</h1>
            </div>

            <div>
              <button className="cta3-cc" onClick={scrollToTop}>
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="section-8b-cc" style={{borderBottom:"0.99px solid #BEBEBE"}}>
          <img src="/assets/images/custom-checkout/iso.png" alt="" />
          <img src="/assets/images/custom-checkout/pci.png" alt="" />
          <img src="/assets/images/custom-checkout/gdpr.png" alt="" />
        </div>
      </div>
      <div className="section-eight-cc">
        <div
          style={{
            minHeight: "70vh",
            padding: "0",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "700px",
              margin: isMobile ? "0 20px " : "0 auto",
            }}
          >
            <h1
              style={{
                textAlign: "center",
                color: "#000",
                fontSize: "2.5rem",
                fontWeight: 400,
                marginBottom: "36px",
                // fontFamily: "Inter, Arial, sans-serif"
              }}
            >
              FAQs
            </h1>
            <div>
              {FAQData.map((faq, idx) => (
                <div
                  key={faq.questNo}
                  style={{
                    background: "#fff",
                    borderRadius: "7px",
                    boxShadow: "0 1px 2px 0 rgba(16,24,40,0.04)",
                    marginBottom: "16px",
                    overflow: "hidden",
                    border: "1px solid #eee",
                  }}
                >
                  <button
                    style={{
                      width: "100%",
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      padding: 0,
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    onClick={() => toggleAccordion(idx)}
                    aria-expanded={activeIndex === idx}
                    aria-controls={`faq-response-${idx}`}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: "1.1rem",
                        fontWeight: 500,
                        background: "#F8F8F8",
                        color: "#111",
                        padding: "18px 20px",
                        // fontFamily: "Inter, Arial, sans-serif"
                      }}
                    >
                      <span>{faq.quest}</span>
                      <span
                        style={{
                          marginLeft: "20px",
                          color: "#222",
                          fontSize: "19px",
                          display: "flex",
                          alignItems: "center",
                          background: "#F8F8F8",
                        }}
                      >
                        {activeIndex === idx ? <FiMinus /> : <FaPlus />}
                      </span>
                    </div>
                  </button>
                  <div
                    id={`faq-response-${idx}`}
                    style={{
                      maxHeight: activeIndex === idx ? "500px" : "0", // larger maxHeight than expected content
                      overflow: "hidden",
                      background: "#F8F8F8",
                      transition:
                        "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease",
                      padding:
                        activeIndex === idx ? "0 20px 16px 20px" : "0 20px",
                      opacity: activeIndex === idx ? 1 : 0,
                      fontSize: "1.05rem",
                      color: "#333",
                    }}
                  >
                    <div style={{ paddingTop: "4px", paddingBottom: "2px" }}>
                      {faq.response}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionEight;
